module.exports = __webpack_public_path__ + "static/map-large-a0348076d45844219d34fae9bc4f9673.png";